import { render, staticRenderFns } from "./DelChatMessage.vue?vue&type=template&id=079c27c0&scoped=true&lang=pug&"
import script from "./DelChatMessage.vue?vue&type=script&lang=js&"
export * from "./DelChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./DelChatMessage.vue?vue&type=style&index=0&id=079c27c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c27c0",
  null
  
)

export default component.exports